
        document.addEventListener("DOMContentLoaded", function () {
            const shopLookBtns = document.querySelectorAll(".shop-look");
            const popBody = document.querySelector("body");
            shopLookBtns.forEach(function (btn) {
                btn.addEventListener("click", function () {
                    // sabhi popups se active class hatao
                    document.querySelectorAll(".popup-content").forEach(function (popup) {
                        popup.classList.remove("active");
                        
                    });

                    // sirf is button ka next wala popup target karo
                    const popup = btn.parentElement.nextElementSibling;
                    if (popup && popup.classList.contains("popup-content")) {
                        popup.classList.add("active");
                        popBody.classList.add("overflow-hidden");
                    }
                });
            });

            // cross-icon click par close
            document.querySelectorAll(".popup-content .cross-icon").forEach(function (cross) {
                cross.addEventListener("click", function () {
                    cross.closest(".popup-content").classList.remove("active");
                    popBody.classList.remove("overflow-hidden");
                });
            });

            // overlay click par close
            document.querySelectorAll(".popup-content .popup-overlay").forEach(function (overlay) {
                overlay.addEventListener("click", function () {
                    overlay.closest(".popup-content").classList.remove("active");
                    popBody.classList.remove("overflow-hidden");
                });
            });
        });

        try {
          loadAjaxImages();
        } catch(err) {console.log(err);}